// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"221":"AuthForm","370":"ReportPage","475":"MainPage"}[chunkId] || chunkId) + "." + {"38":"82db1a50","221":"27e0a23f","370":"b695afdb","475":"43972bdb"}[chunkId] + ".chunk.css";
};